const getPathToFavicon = (dark: boolean) => {
  if (dark) {
    return '/favicon-dark.png';
  }

  return '/favicon.png';
};

const updateFavicon = (dark: boolean) => {
  const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

  if (!favicon) return;
  favicon.href = getPathToFavicon(dark);
};

export const initFaviconManager = () => {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  updateFavicon(mediaQuery.matches);
  mediaQuery.addEventListener('change', (event) => {
    updateFavicon(event.matches);
  });
};
